import { render, staticRenderFns } from "./NewRirekishoEdit.vue?vue&type=template&id=343de976&scoped=true"
import script from "./NewRirekishoEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewRirekishoEdit.vue?vue&type=style&index=0&id=343de976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343de976",
  null
  
)

export default component.exports